import React, { useState } from 'react';
import './pricing.css';

const Pricing = ({ pricingId = "pricing" }) => {
  const [activeGroup, setActiveGroup] = useState('basic');
  const [activeTab, setActiveTab] = useState('oneEntry');

  const categoryGroups = {
    basic: {
      label: 'Základní',
      tabs: [
        { id: 'oneEntry', label: '1 vstup' },
        { id: 'monthly', label: 'měsíční' },
        { id: 'timelimited', label: 'timelimited' }
      ]
    },
    multiEntry: {
      label: 'Vícevstupové',
      tabs: [
        { id: 'tenEntry', label: '10 vstupů' },
        { id: 'twentyFiveEntry', label: '25 vstupů' },
        { id: 'fiftyEntry', label: '50 vstupů' }
      ]
    },
    longTerm: {
      label: 'Dlouhodobé členství',
      tabs: [
        { id: 'threeMonths', label: '3 měsíce' },
        { id: 'sixMonths', label: '6 měsíců' },
        { id: 'twelveMonths', label: '12 měsíců' }
      ]
    },
    diagnostics: {
      label: 'Diagnostické služby',
      tabs: [
        { id: 'diagnostics', label: 'diagnostické služby' }
      ]
    }
  };

  const handleGroupChange = (groupId) => {
    setActiveGroup(groupId);
    const firstTab = categoryGroups[groupId].tabs[0].id;
    setActiveTab(firstTab);
  };

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const handleMobileChange = (tabId) => {
    setActiveTab(tabId);
    for (const [groupId, group] of Object.entries(categoryGroups)) {
      if (group.tabs.some(tab => tab.id === tabId)) {
        setActiveGroup(groupId);
        break;
      }
    }
  };

  const pricingData = {
    diagnostics: {
      title: "Diagnostické služby",
      cards: [
        {
          category: "Diagnostické měření",
          type: "kompletní analýza",
          features: [
            "tělesný a viscerální tuk",
            "BMI",
            "tělesná voda",
            "svalová a beztuková hmota",
            "sarcopenic index",
            "váha kostí",
            "basální metabolismus"
          ],
          price: "150 Kč"
        },
        {
          category: "Sledování pokroku",
          type: "porovnání měření",
          features: [
            "porovnání dvou či více diagnostických měření s časovou křivkou"
          ],
          price: "250 Kč"
        }
      ]
    },
    oneEntry: {
      title: "1 vstup",
      cards: [
        {
          category: "Muži",
          type: "1 vstup",
          features: ["pokud se vám u nás líbí, doporučujeme měsíční nebo vícevstupovou permanentku"],
          price: "125 Kč"
        },
        {
          category: "Ženy",
          type: "1 vstup",
          features: ["pokud se vám u nás líbí, doporučujeme měsíční nebo vícevstupovou permanentku"],
          price: "125 Kč"
        },
        {
          category: "Studenti",
          type: "1 vstup",
          features: ["pokud se vám u nás líbí, doporučujeme měsíční nebo vícevstupovou permanentku"],
          price: "125 Kč"
        }
      ]
    },
    monthly: {
      title: "Měsíční permanentka",
      cards: [
        {
          category: "Muži",
          type: "měsíční",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma"
          ],
          price: "1 100 Kč"
        },
        {
          category: "Ženy",
          type: "měsíční",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma"
          ],
          price: "990 Kč"
        },
        {
          category: "Studenti",
          type: "měsíční",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma"
          ],
          price: "850 Kč"
        }
      ]
    },
    timelimited: {
      title: "Timelimited permanentka",
      cards: [
        {
          category: "Muži",
          type: "timelimited",
          description: "Zvýhodněná měsíční permanentka pro klienty s odchodem do 13:00 nebo příchodem po 19:00, v mezičase příplatek 50 Kč",
          features: [
            "vyžaduje depozit 250 Kč",
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma"
          ],
          price: "850 Kč"
        },
        {
          category: "Ženy",
          type: "timelimited",
          description: "Zvýhodněná měsíční permanentka pro klientky s odchodem do 13:00 nebo příchodem po 19:00, v mezičase příplatek 50 Kč",
          features: [
            "vyžaduje depozit 200 Kč",
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma"
          ],
          price: "790 Kč"
        },
        {
          category: "Studenti",
          type: "summer time",
          description: "Zvýhodněná měsíční permanentka pro klienty s odchodem do 13:00 nebo příchodem po 19:00, v mezičase příplatek 50 Kč",
          features: [
            "platnost pouze na období od 1. 7. do 31. 8.",
            "vyžaduje depozit 400 Kč",
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma"
          ],
          price: "1 300 Kč"
        }
      ]
    },
    threeMonths: {
      title: "Členství 3 měsíce",
      cards: [
        {
          category: "Muži",
          type: "3 měsíce",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma",
            "lze zakoupit pouze v hotovosti na recepci",
            "nelze využít slevu za dobití depozitu"
          ],
          price: "2 990 Kč"
        },
        {
          category: "Ženy",
          type: "3 měsíce",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma",
            "lze zakoupit pouze v hotovosti na recepci",
            "nelze využít slevu za dobití depozitu"
          ],
          price: "2 690 Kč"
        },
        {
          category: "Studenti",
          type: "3 měsíce",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma",
            "lze zakoupit pouze v hotovosti na recepci",
            "nelze využít slevu za dobití depozitu"
          ],
          price: "2 290 Kč"
        }
      ]
    },
    sixMonths: {
      title: "Členství 6 měsíců",
      cards: [
        {
          category: "Muži",
          type: "6 měsíců",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma",
            "lze zakoupit pouze v hotovosti na recepci",
            "nelze využít slevu za dobití depozitu"
          ],
          price: "5 490 Kč"
        },
        {
          category: "Ženy",
          type: "6 měsíců",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma",
            "lze zakoupit pouze v hotovosti na recepci",
            "nelze využít slevu za dobití depozitu"
          ],
          price: "4 990 Kč"
        },
        {
          category: "Studenti",
          type: "6 měsíců",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma",
            "lze zakoupit pouze v hotovosti na recepci",
            "nelze využít slevu za dobití depozitu"
          ],
          price: "4 490 Kč"
        }
      ]
    },
    twelveMonths: {
      title: "Členství 12 měsíců",
      cards: [
        {
          category: "Muži",
          type: "12 měsíců",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma",
            "lze zakoupit pouze v hotovosti na recepci",
            "nelze využít slevu za dobití depozitu"
          ],
          price: "9 900 Kč"
        },
        {
          category: "Ženy",
          type: "12 měsíců",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma",
            "lze zakoupit pouze v hotovosti na recepci",
            "nelze využít slevu za dobití depozitu"
          ],
          price: "8 900 Kč"
        },
        {
          category: "Studenti",
          type: "12 měsíců",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "kohoutková voda zdarma",
            "lze zakoupit pouze v hotovosti na recepci",
            "nelze využít slevu za dobití depozitu"
          ],
          price: "7 900 Kč"
        }
      ]
    },
    tenEntry: {
      title: "10 vstupů",
      cards: [
        {
          category: "Muži",
          type: "10 vstupů",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "platnost permanentky 3 měsíce"
          ],
          price: "1 000 Kč"
        },
        {
          category: "Ženy",
          type: "10 vstupů",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "platnost permanentky 3 měsíce"
          ],
          price: "950 Kč"
        },
        {
          category: "Studenti",
          type: "10 vstupů",
          features: [
            "diagnostické měření na diagnostické váze za 50 Kč",
            "platnost permanentky 3 měsíce"
          ],
          price: "900 Kč"
        }
      ]
    },
    twentyFiveEntry: {
      title: "25 vstupů",
      cards: [
        {
          category: "Muži",
          type: "25 vstupů",
          features: [
            "1x diagnostické měření na diagnostické váze zdarma",
            "platnost permanentky 6 měsíců"
          ],
          price: "2 375 Kč"
        },
        {
          category: "Ženy",
          type: "25 vstupů",
          features: [
            "1x diagnostické měření na diagnostické váze zdarma",
            "platnost permanentky 6 měsíců"
          ],
          price: "2 250 Kč"
        },
        {
          category: "Studenti",
          type: "25 vstupů",
          features: [
            "1x diagnostické měření na diagnostické váze zdarma",
            "platnost permanentky 6 měsíců"
          ],
          price: "2 125 Kč"
        }
      ]
    },
    fiftyEntry: {
      title: "50 vstupů",
      cards: [
        {
          category: "Muži",
          type: "50 vstupů",
          features: [
            "2x diagnostické měření na diagnostické váze zdarma",
            "platnost permanentky 12 měsíců"
          ],
          price: "4 500 Kč"
        },
        {
          category: "Ženy",
          type: "50 vstupů",
          features: [
            "2x diagnostické měření na diagnostické váze zdarma",
            "platnost permanentky 12 měsíců"
          ],
          price: "4 250 Kč"
        },
        {
          category: "Studenti",
          type: "50 vstupů",
          features: [
            "2x diagnostické měření na diagnostické váze zdarma",
            "platnost permanentky 12 měsíců"
          ],
          price: "4 000 Kč"
        }
      ]
    }
  };

  const currentData = pricingData[activeTab];
  const currentGroupTabs = categoryGroups[activeGroup].tabs;
  const hasSubcategories = currentGroupTabs.length > 1;

  return (
    <div id={pricingId} className="pricing-section">
      <div className="pricing-container">
        <div className="pricing-header">
          <h2 className="pricing-title">
            Vyber si svůj dokonalý plán
          </h2>
          <p className="pricing-description">
            Díky <span className="pricing-highlight">výhodným</span> balíčků služeb si vybere opravdu každý.{' '}
            <span className="pricing-highlight">První vstup</span> máte po registraci na recepci od nás{' '}
            Grátis. Akceptujeme <span className="pricing-highlight">Multisport</span> karty. V případě závažného úrazu po předložení lékařského potvrzení Vám můžeme prodloužit či pozastavit permanentku až o 90 dnů. Více info na recepci.{' '}
            <span className="pricing-highlight">Studentské</span> permanentky poskytujeme pouze na základě platného isic, nebo potvrzení o studiu vystavené méně než před 90 dny.
          </p>
        </div>

        <div className="pricing-controls">
          <select 
            className="main-select"
            value={activeGroup}
            onChange={(e) => handleGroupChange(e.target.value)}
          >
            {Object.entries(categoryGroups).map(([groupId, group]) => (
              <option key={groupId} value={groupId}>
                {group.label}
              </option>
            ))}
          </select>

          {hasSubcategories && (
            <div className="subcategory-tiles">
              {currentGroupTabs.map(tab => (
                <button
                  key={tab.id}
                  className={`tile-button ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => handleTabChange(tab.id)}
                >
                  <span>{tab.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <div className={`pricing-cards ${activeTab === 'diagnostics' ? 'diagnostics-grid' : ''}`}>
          {currentData.cards.map((card, index) => (
            <div key={index} className="pricing-card">
              <div className="card-header">
                <h3 className="card-category">{card.category}</h3>
                <h4 className="card-type">{card.type}</h4>
                {card.description && (
                  <p className="card-description">{card.description}</p>
                )}
              </div>
              
              <ul className="card-features">
                {card.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
              
              <button className="card-price">
                {card.price}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pricing;